// extracted by mini-css-extract-plugin
export default {"link":"TopBanner_link__FUNqC","container":"TopBanner_container__wcEcf"};